import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../shareds/translate/translate.service';

/** locale ของ Intl ตาม code ภาษาใน languages.json */
const LOCALES: Record<string, string> = { en: 'en-GB', ch: 'zh-CN', ru: 'ru-RU' };

@Pipe({
  name: 'thaidate',
  standalone: true,
  pure: false // อัปเดตเมื่อเปลี่ยนภาษา
})
export class ThaidatePipe implements PipeTransform {
  private translate = inject(TranslateService);

  private months = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
  private days = ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'];

  transform(value: Date | string | number | null | undefined, format: 'short' | 'long' = 'short'): string {
    if (!value) return '-';
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return '-';

    const locale = LOCALES[this.translate.language()?.code ?? ''];
    if (locale) {
      return d.toLocaleDateString(locale, format === 'long'
        ? { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }
        : { day: 'numeric', month: 'short', year: 'numeric' });
    }

    const dateStr = `${d.getDate()} ${this.months[d.getMonth()]} ${d.getFullYear()}`;
    if (format === 'long') {
      return `${this.days[d.getDay()]} ที่ ${dateStr}`;
    }
    return dateStr;
  }

}
